import { LastUpdatedBy } from '../Shared/LastUpdatedBy.model';

export default interface ISingleSignatureStatus {
    SignatureStatus: string;
    SignatureDate: Date | null;
    LastReviewedBy: LastUpdatedBy | null;
}

export class SingleSignatureStatus implements ISingleSignatureStatus {
    SignatureStatus: string;
    SignatureDate: Date | null;
    LastReviewedBy: LastUpdatedBy | null;

    constructor() {
        this.SignatureStatus = '';
        this.SignatureDate = null;
        this.LastReviewedBy = null;
    }
}
